import { ScaleType } from '@tonaljs/tonal';
import _ from 'lodash';
import { addAlias } from '@tonaljs/scale-type';

const addScaleTypeAlias = (name, alias) =>
{
  let scaletype = ScaleType.get(name);
  if(scaletype.empty)
  {
    return;
  }
  scaletype.aliases = _.union(scaletype.aliases, [alias]);
  addAlias(scaletype, alias); 
}
const ScaleExtensions = () => {
  addScaleTypeAlias('major pentatonic', 'pentatonic major');
  addScaleTypeAlias('minor pentatonic', 'pentatonic minor');
  addScaleTypeAlias('minor', 'natural minor');
  addScaleTypeAlias('locrian #2', 'locrian natural 9');
}
export { ScaleExtensions } 
